<ngx3js-renderer
    [alpha]="true"
    [controlType]="'orbit'"
    #renderer3d
    (onRender)="onAnimate()"
    (mousemove)="onMouseMove($event)"
>
    <ngx3js-camera #camera>
        <ngx3js-position [x]="-50" [y]="0" [z]="-50"></ngx3js-position>
    </ngx3js-camera>

    <ngx3js-scene #scene>
        <!-- Luces -->
        <ngx3js-light
            [type]="'AmbientLight'"
            [color]="'0xffffff'"
            [intensity]="0.8"
        ></ngx3js-light>
        <ngx3js-light [type]="'DirectionalLight'" [intensity]="0.8">
            <ngx3js-position [x]="-3" [y]="10" [z]="-10"></ngx3js-position>
        </ngx3js-light>

        <!-- 🧊 Cubo transparente (contenedor) -->
        <ngx3js-mesh  #containerMesh>
            <ngx3js-geometry
                [type]="'box'"
                [width]="width"
                [height]="height"
                [depth]="depth"
            >
            </ngx3js-geometry>

            <!-- <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#88ccee'"
                [transparent]="true"
                [opacity]="0.3"
                [metalness]="0.4"
                [roughness]="0.1"
                [reflectivity]="1"
                [clearcoat]="1"
                [clearcoatRoughness]="0.05"
                [side]="'DoubleSide'"
            > -->
            <ngx3js-material
                [type]="'meshphysical'"
                [color]="'#88ccee'"
                [transparent]="true"
                [opacity]="0.25"
                [metalness]="0.1"
                [roughness]="0"
                [reflectivity]="1"
                [clearcoat]="1"    
                [clearcoatRoughness]="0"
                [side]="'DoubleSide'"
            >
            </ngx3js-material>
        </ngx3js-mesh>

        <!-- 💧 Contenido interno (líquido o relleno) -->
        <ngx3js-mesh #liquidMesh>
            <ngx3js-geometry
                [type]="'box'"
                [width]="width - 1"
                [height]="height * percentageFull"
                [depth]="depth - 1"
            ></ngx3js-geometry>
            <ngx3js-material
                [type]="'meshstandard'"
                [color]="liquidColor"
                [transparent]="true"
                [opacity]="0.6"
            ></ngx3js-material>
            <ngx3js-position
                [x]="0"
                [y]="-height * 0.25"
                [z]="0"
            ></ngx3js-position>
        </ngx3js-mesh>
    </ngx3js-scene>
</ngx3js-renderer>

<!-- Tooltip -->
<div
    *ngIf="tooltipVisible"
    class="tooltip-container"
    [ngStyle]="{
        top: tooltipY + 'px',
        left: tooltipX + 'px'
    }"
>
    <!-- {{ tooltipText }} -->
    <div class="row">
        <h5 class="text-white">Bodega: Prueba 2</h5>
        <span>Capacidad MAX: 34563</span>
        <span>Estado: 50%</span>
        <span>Otro valor: 34563</span>
        <span>valores: 34563</span>
    </div>
</div>
